import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { AccessibleContent, PresentationContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { Tooltip } from '@instructure/ui-tooltip';
import t from 'format-message';
import { TruncateText } from '@instructure/ui-truncate-text';
import { withStyle, jsx } from '@instructure/emotion';
import OutcomeViewModal from "../../OutcomeViewModal/index.js";
import HeaderDetails from "../HeaderDetails/index.js";
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../../store/shapes.js";
var Header = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);
  var _super = _createSuper(Header);
  function Header(props) {
    var _this;
    _classCallCheck(this, Header);
    _this = _super.call(this, props);
    _this.handleUpdate = function (isTruncated) {
      if (isTruncated !== _this.state.showTooltip) {
        _this.setState({
          showTooltip: isTruncated
        });
      }
    };
    _this.renderTitle = function (outcome) {
      var viewReportAlignment = _this.props.viewReportAlignment;
      return jsx(Link, {
        onClick: viewReportAlignment
      }, jsx(Text, {
        size: "medium",
        transform: "uppercase"
      }, jsx(TruncateText, {
        maxLines: 1,
        position: 'middle',
        onUpdate: _this.handleUpdate
      }, jsx(AccessibleContent, {
        alt: outcome.title
      }, outcome.title))));
    };
    _this.state = {
      showTooltip: false
    };
    return _this;
  }
  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        outcomeResult = _this$props.outcomeResult,
        getReportOutcome = _this$props.getReportOutcome,
        isOpen = _this$props.isOpen,
        closeReportAlignment = _this$props.closeReportAlignment,
        showRollups = _this$props.showRollups,
        scope = _this$props.scope;
      var showTooltip = this.state.showTooltip;
      var outcome = getReportOutcome(outcomeResult.outcomeId);
      return jsx("div", {
        css: this.props.styles.header
      }, showTooltip ? jsx(Tooltip, {
        renderTip: outcome.title,
        placement: "bottom",
        color: "primary"
      }, this.renderTitle(outcome)) : this.renderTitle(outcome), jsx(PresentationContent, null, jsx(HeaderDetails, {
        outcomeResult: outcomeResult,
        showRollups: showRollups
      })), jsx(OutcomeViewModal, {
        header: t('Outcome Detail'),
        outcome: outcome,
        outcomeResult: outcomeResult,
        closeAlignment: closeReportAlignment,
        isOpen: isOpen,
        scope: scope,
        displayMasteryDescription: true
      }));
    }
  }]);
  Header.displayName = "Header";
  return Header;
}(React.Component), _class2.propTypes = {
  outcomeResult: PropTypes.object.isRequired,
  getReportOutcome: PropTypes.func.isRequired,
  viewReportAlignment: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeReportAlignment: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
  showRollups: PropTypes.bool,
  styles: stylesShape
}, _class2.defaultProps = {
  showRollups: true
}, _class2)) || _class);
export { Header as default };